import styled from 'styled-components'
import Clear from '@material-ui/icons/Clear'
import { Grid, FormControl, Select, CircularProgress } from '@material-ui/core'
import { theme, StyledDialogContent as DialogContent } from '../../../../../../theme/Global'

export const StyledCloseButton = styled(Clear)`
  &&& {
    float: right;
    height: 45px;
    width: 45px;
  }
`

export const StyledDialogContent = styled(DialogContent)`
  &&& {
    min-height: unset;
  }
`

export const StyledProductGrid = styled(Grid)`
  &&& {
    margin-top: 1rem;
  }
`
export const StyledSelect = styled(Select)`
  &&& {
    color: ${theme.colors.text}; 
    font-size: 12pt;
    text-align: left;
  }
`
export const StyledFormControl = styled(FormControl)`
  &&& {
    width: 80%;
  }
`
export const StyledButtonsGrid = styled(Grid)`
  &&& {
    margin: 2rem 0 0.5rem;
    justify-content: flex-start;
    display: flex;
  }
`
export const StyledExportContainer = styled(Grid)`
  &&& {
    padding-left: 0;
  }
`

export const StyledCircularProgress = styled(CircularProgress)`
  &&& {
    margin-left: 20px;
    margin-top: 12px;
  }
`
